import { render } from "./BulkSubmitList.vue?vue&type=template&id=ea9f0650&scoped=true"
import script from "./BulkSubmitList.vue?vue&type=script&lang=js"
export * from "./BulkSubmitList.vue?vue&type=script&lang=js"

import "./BulkSubmitList.vue?vue&type=style&index=0&id=ea9f0650&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ea9f0650"

export default script